
import { defineComponent } from 'vue';
import ButtonComponent from "@/components/appComponents/Button.vue";
import store from '@/store';

export default defineComponent({
    name: "DocumentDialogComponent",

    props: ["document"],

    components: { ButtonComponent },

    data() {
        return {
            baseUrlImage: 'https://storage.sayyarpay.top/',
            activeImage: 'national',
            id: this.document.id,
            userId: this.document.userId,
            firstName: this.document.firstName,
            nationalCode: this.document.nationalCode,
            birthDate: this.document.birthDate,
            nationalImageUrl: this.document.nationalImageUrl,
            selfieImageUrl: this.document.selfieImageUrl,
            submittedAt: this.document.submittedAt,
            reject: false,
            rejectMessage: ""
        }
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },
    },

    methods: {
        submitModalConfirm() {
            const data = {
                userId: this.document.userId,
                reject: this.reject,
                message: this.rejectMessage,
            };

            this.$emit("submit", data);
        },

        cancel() {
            this.$emit("cancel");
        }
    },
})
